module.exports = __webpack_public_path__ + "img/LI-In-Bug_gold.39ddadd4.png";